import {createSelector} from '@reduxjs/toolkit';

import {getCartTotalPrice, getQuoteItems} from 'desktop/pages/cart/store/selectors';
import {CartItemType} from 'desktop/pages/cart/types';
import {PLA} from 'desktop/pages/checkout/constants/checkout';
import {getCurrentRebateDiscount} from 'desktop/pages/checkout/store/selectors/orderReviewTotals/utils/rebateDiscount';

/**
 * It counts sum applying rebate discounts
 * @return {number} rebate discount sum
 */
export const getTotalRebateSum = createSelector(getQuoteItems, (items: Array<CartItemType>) =>
    items.reduce((acc: number, item) => {
        if (item.sku.match(PLA) !== null) return acc;

        if (item.rebate_discounts) {
            return acc + (getCurrentRebateDiscount(item.rebate_discounts, Number(item.qty)) || 0);
        }

        return acc;
    }, 0),
);

/**
 * It counts total after applying rebate discount
 * @return {number} total with applied rebate discount
 */
export const getCartTotalWithRebate = createSelector(
    getTotalRebateSum,
    getCartTotalPrice,
    (totalRebateDiscount: number, total: number) => total - totalRebateDiscount,
);
